import { render } from "./blog_single.vue?vue&type=template&id=12e9c864"
import script from "./blog_single.vue?vue&type=script&lang=js"
export * from "./blog_single.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__